import { RootState } from 'state/store'

export const selectBaseToken = (state: RootState) => state.manage.listPair.baseToken

export const selectQuoteToken = (state: RootState) => state.manage.listPair.quoteToken

export const selectInitialPrice = (state: RootState) => state.manage.listPair.initialPrice

export const selectCustomMarkets = (state: RootState) => state.manage.customMarkets

export const selectCustomMarketsStatus = (state: RootState) => state.manage.queryStatuses.customMarkets

export const selectAllTokens = (state: RootState) => state.manage.allTokens

export const selectAllMarkets = (state: RootState) => state.manage.allMarkets

export const selectAllTokensStatus = (state: RootState) => state.manage.queryStatuses.allTokens

export const selectCreateMarketStatus = (state: RootState) => state.manage.writeStatuses.createMarket

export const selectAddPairToMarketStatus = (state: RootState) => state.manage.writeStatuses.addPairToMarket
export const selectFeeTier = (state: RootState) => state.manage.listPair.feeTier
